import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, LogIn, Sparkles } from "lucide-react";
import logo from "../../assets/weeker_ai_logo_darkbg.png";

const navLinks = [
  { label: "Funktionen", href: "/#features" },
  { label: "So funktioniert's", href: "/#how-it-works" },
  { label: "Preise", href: "/pricing" },
];

const Header = ({ auth }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Consistency Colors
  const navBg = "#334155";

  return (
    <header
      className="sticky-top transition-all"
      style={{
        backgroundColor: navBg,
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        zIndex: 1100
      }}
    >
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="d-flex align-items-center justify-content-between" style={{ height: "64px" }}>

          {/* Logo */}
          <a className="navbar-brand d-flex align-items-center p-0" href="/">
            <img
              src={logo}
              alt="WeekerAI"
              style={{ height: "45px", width: "auto" }}
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="d-none d-lg-flex align-items-center gap-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-white-50 text-decoration-none fw-medium small hover-text-white transition-all"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop Actions */}
          <div className="d-none d-lg-flex align-items-center gap-2">
            <button
              className="btn btn-link text-white-50 text-decoration-none fw-bold small hover-text-white"
              onClick={() => auth.login()}
            >
              <LogIn size={16} className="me-1" /> Login
            </button>
            <button
              className="btn btn-primary btn-sm px-4 fw-bold rounded-pill shadow-sm"
              onClick={() => auth.login()}
            >
              <Sparkles size={14} className="me-1" /> Kostenlos starten
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="d-lg-none p-2 text-white bg-transparent border-0 shadow-none"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        {mobileMenuOpen && (
          <div
            className="d-lg-none py-4 animate-fade-in border-top border-white border-opacity-10"
            style={{ backgroundColor: navBg }}
          >
            <nav className="d-flex flex-column gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-white-50 small fw-bold text-decoration-none py-3 px-2 rounded-3 hover-bg-slate"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}

              <div className="d-flex flex-column gap-2 pt-4 mt-2 border-top border-white border-opacity-10">
                <button
                  className="btn btn-outline-light w-100 fw-bold py-2 shadow-none"
                  onClick={() => auth.login()}
                >
                  Login
                </button>

                <button
                  className="btn btn-primary w-100 fw-bold py-2 shadow-sm"
                  onClick={() => auth.login()}
                >
                  Kostenlos starten
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>

      <style>{`
        .hover-text-white:hover { color: #fff !important; }
        .hover-bg-slate:hover { background-color: rgba(255,255,255,0.05); color: #fff !important; }
        .animate-fade-in {
          animation: fadeIn 0.2s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </header>
  );
};

export default Header;